/** Fila RW/NR del packing list: sin validar pcs/paq × paquetes = total piezas (como en PDF). */
export function isRwNrPackingListRow(row) {
  const txt = `${row?.productos_texto ?? ''} ${row?.grado_celda ?? ''}`.toUpperCase();
  if (/\b(RW\/NR|RW|WR|NR)\b/.test(txt)) return true;
  const ancho = String(row?.ancho ?? '').trim();
  return /^\s*RW\s*$/i.test(ancho);
}
